<template>
  <div class="container-full flex-wrap" style="align-items:stretch;height:100%;overflow:hidden;position:relative;">
    <div style="width:200px;border-right:1px solid var(--border)">
        <BaseMenu :menus="items" :actived="actived" @on-click="handleClick" />
    </div>
    <div style="width:calc(100% - 200px);height:100%;overflow:hidden;position:relative;">
        <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  routerOption: {
    as_frame: true,
  },
  computed: {
    actived() {
      return this.$route.path.slice(this.$route.path.lastIndexOf('/')+1);
    },
    session() {
      return this.$store.getters['session/session'];
    },
    items() {
      const normal = [{
        icon: 'md-list',
        name: '视图数据',
        key: 'view',
      }, {
        icon: 'md-cube',
        name: '阶段数据',
        key: 'phase',
      }, {
        icon: 'md-cube',
        name: '模块数据',
        key: 'work',
      },{
        icon:'md-list',
        name:'时间数据',
        key:'daily'
      }, {
        icon: 'md-list',
        name: '任务数据',
        key: 'task',
      }, {
        icon: 'md-apps',
        name: '分类数据',
        key: 'category',
      }, {
        icon: 'md-person',
        name: '岗位数据',
        key: 'person',
      }];
      const mgr = [{
        icon: 'md-list',
        name: '管理数据',
        key: 'mgr',
      }];
      let items = [...normal];
      if (this.session.roles && this.session.roles.filter((v)=>v.name && v.name.includes('事业部')).length > 0) {
        items = items.concat(mgr);
      }
      return items;
    },
  },
  methods: {
    handleClick(e) {
      this.RouteTo(e);
    },
  },
};
</script>

<style>

</style>
